import { X } from 'lucide-react';
import React from 'react';
import { Button, Input, XStack, YStack } from 'tamagui';
import { tokens } from 'tamagui-config';

import { CustomKeyboard, GradientButton } from './index';

interface KeyboardInputProps {
  input: string;
  onInputChange: (val: string) => void;
  onSubmit?: () => void;
  onCancel: () => void;
  showModal: boolean;
  inputRef: React.RefObject<any>;
  keyboardRef: React.RefObject<any>;
  onKeyboardChange: (val: string) => void;
  buttonLabel?: string;
  placeholder?: string;
}

export const KeyboardInput: React.FC<KeyboardInputProps> = ({
  input,
  onInputChange,
  onSubmit,
  onCancel,
  showModal,
  inputRef,
  keyboardRef,
  onKeyboardChange,
  buttonLabel = 'Connect',
  placeholder = 'Wifi Password',
}) => (
  <YStack alignItems="center" width="100%">
    <XStack width="100%" alignItems="center" justifyContent="space-between" gap="$5" padding="$5">
      <Button
        icon={<X size={24} strokeWidth={4} color={tokens.color.white12} />}
        circular
        minWidth={72}
        minHeight={72}
        borderWidth="$1"
        borderColor="$transparentBorder"
        backgroundColor="$transparentBorder"
        onPress={onCancel}
      />
      <Input
        ref={inputRef}
        height={72}
        width={'100%'}
        paddingVertical={16}
        paddingHorizontal={24}
        alignItems="center"
        alignSelf="stretch"
        borderRadius={7}
        borderWidth={1}
        backgroundColor="$formInputBackground"
        borderColor={showModal ? '$warningRed' : '$gray8'}
        fontSize="$8.5"
        placeholder={placeholder}
        value={input}
        onChangeText={onInputChange}
        focusStyle={{
          borderColor: '$gray8',
          borderWidth: 1,
          outlineWidth: 0,
          outlineStyle: 'none',
        }}
        focusVisibleStyle={{
          outlineWidth: 0,
          outlineStyle: 'none',
        }}
        autoFocus
      />

      <GradientButton label={buttonLabel} isActive={true} onPress={onSubmit} width="168px" />
    </XStack>
    <XStack width="1142px" padding="$2">
      <CustomKeyboard
        input={input}
        onChange={onKeyboardChange}
        keyboardRef={keyboardRef}
        onEnter={onSubmit}
      />
    </XStack>
  </YStack>
);
